import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';

export const getFranceUSPFeature = ({ hasFranceUSP, isHO, t }: GetFeaturesInnerParams): Feature[] => {
  if (!hasFranceUSP || isHO) return [];

  return [
    {
      text: t('vacation.oss.cards.french_assistance'),
      featureType: FeatureType.normal,
    },
  ];
};
